import {
  FETCH_DELIVERY_STAFF_FAILURE,
  FETCH_DELIVERY_STAFF_REQUEST,
  FETCH_DELIVERY_STAFF_SUCCESS,
  RESET_DELIVERY_STAFF_DATA
} from "../../constants/actionTypes";

const initialState = {
  data: {
    count: 0,
    users: []
  },

  dataFetched: false,
  isFetching: false,
  error: false,

  dataPosted: false,
  isPosting: false
};

export const deliveryStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_DELIVERY_STAFF_DATA:
      return initialState;

    case FETCH_DELIVERY_STAFF_REQUEST:
      return {
        ...state,
        dataFetched: false,
        isFetching: true,
        error: false
      };
    case FETCH_DELIVERY_STAFF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        dataFetched: true,
        data: action.payload
      };
    case FETCH_DELIVERY_STAFF_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default deliveryStaffReducer;
